import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, HelpCircle } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Es un reemplazo de la terapia tradicional?',
    a: 'No reemplaza un proceso psicoterapéutico profundo para patologías graves, pero funciona como un excelente primer paso, un puente o un manual de herramientas cotidianas avaladas por la ciencia.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'De forma inmediata. Una vez realizado el pago, te llega un correo automatizado con los enlaces para descargar el libro y todos los bonos en formato PDF/Epub para leer desde el celular, tablet o computadora.'
  }, {
    q: '¿Qué métodos de pago aceptan?',
    a: 'Aceptamos todos los medios de pago locales a través de Mercado Pago (tarjeta de crédito, débito, dinero en cuenta o Rapipago/Pago Fácil).'
  }, {
    q: '¿Necesito conocimientos previos de psicología?',
    a: 'Para nada. El fuerte de Liz Kelly es explicar conceptos hipercomplejos con un lenguaje súper sencillo, cotidiano y con mucho humor.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-12 md:py-16 bg-white" data-id="element-90">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-91">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-92">
          <div className="inline-flex items-center justify-center gap-2 text-coral font-bold tracking-wider uppercase mb-4" data-id="element-93">
            <HelpCircle className="w-6 h-6" data-id="element-94" />
            <span data-id="element-95">Dudas frecuentes</span>
          </div>
          <h2 className="text-3xl md:text-5xl font-display font-bold text-dark" data-id="element-96">
            PREGUNTAS FRECUENTES
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-97">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="border border-cream-dark rounded-2xl overflow-hidden" data-id="element-98">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left bg-cream hover:bg-cream-dark/50 transition-colors" data-id="element-99">
                <span className="font-display font-bold text-dark text-lg pr-4" data-id="element-100">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-coral flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-101" />
              </button>
              <AnimatePresence data-id="element-102">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-103">
                    <div className="p-6 bg-white text-dark-light border-t border-cream-dark" data-id="element-104">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}